<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2020-03-28 10:52:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 10:19:33
-->
<template>
  <div class="box">
    <AdminHeader @clickClose="close" :isHome="isHome" :isCollapse="isCollapse"  :siteData="siteData" @change="change"/>
    <div class="bottom">
      <Nav  @showContent="showContent" :isCollapse="isCollapse" />
      <right-content :key="siteId" v-if="loading"/>
    </div>
  </div>
</template>

<script>
// 引入组件
import Nav from "@/components/Layout/Nav.vue";
import RightContent from "@/components/Layout/RightContent.vue";
import AdminHeader from "@/components/Layout/AdminHeader.vue";
export default {
  components: {
    Nav,
    RightContent,
    AdminHeader,
  },
  data() {
    return {
      isCollapse: false,
      siteData:[],
      siteId:sessionStorage.getItem('siteId') || 0,
      loading:false,
      loadingTwo:false,
      isHome:false,
    };
  },

  mounted() {
    if(this.$route.path == '/index/home'){
        this.isHome = true;
    }else{
        this.isHome = false;
    }
  },
  // 监听,当路由发生变化的时候执行
  watch:{
    $route(to,from){
      if(to.path == '/index/home'){
          this.isHome = true;
      }else{
         this.isHome = false;
      }
    }
  },
  methods: {
    close() {
      this.isCollapse = !this.isCollapse;
    },
    showContent(){
        this.loading = true;
    },
    change(item){
        sessionStorage.setItem('siteId',item.id)// 缓存站点id
        this.siteId = item.id;
    }
  },
};
</script>

<style lang="less" scoped>
.box {
    height: 100%;
  .bottom {
    display: flex;
    min-height: calc(100% - 60px);
  }
}
::v-deep .el-dialog{
       display: flex;
       flex-direction: column;
       margin:0 !important;
       position:absolute;
       top:50%;
       left:50%;
       transform:translate(-50%,-50%);
       max-height:calc(100% - 30px);
       max-width:calc(100% - 30px);
   }
  ::v-deep  .el-dialog .el-dialog__body{
       flex:1;
       overflow: auto;
   }
</style>